export default "__VITE_ASSET__aCuygmdD__"